import { Button, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CaretRight from "../../../../assets/images/icons/CaretRight";
import { CoachList, Title } from "../../../../components";
import { useLayout } from "../../../../context/LayoutContext";
import { CoachResponse } from "../../../../hooks/Coach/data";
import styles from "./styleModule";

const CoachHot: React.FC<{ coaches: CoachResponse[] }> = ({ coaches }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { getContentPadding } = useLayout();
  const navigate = useNavigate();

  return (
    <div
      className={`${styles.contentWrapper} ${screens.sm ? "" : styles.mobile}`}
      style={{ padding: getContentPadding() }}
    >
      <div className={`${styles.border} ${screens.sm ? "" : styles.mobile}`} />
      <div
        className={`${styles.titleWrapper} ${screens.sm ? "" : styles.mobile}`}
      >
        <Title
          title={t("home.coach.title")}
          subtitle={t("home.coach.subtitle")}
          customTitleContainer={styles.titleContainer}
        />
        {screens.sm ? (
          <Button
            type="link"
            iconPosition={"end"}
            onClick={() => navigate("/trainers")}
            style={{ padding: 0 }}
            icon={
              <CaretRight style={{ fontSize: 24, color: "var(--primary)" }} />
            }
          >
            {t("home.coach.more")}
          </Button>
        ) : null}
      </div>

      <div
        className={`${styles.coachContainer} ${
          screens.sm ? "" : styles.mobile
        }`}
      >
        <CoachList coachList={coaches} />
      </div>
    </div>
  );
};

export default CoachHot;
